import { createFileRoute } from '@tanstack/react-router';
import { ComingSoonPage } from '@/pet/src/components/ComingSoonPage';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/dashboard/booking')({
  component: PetsoBooking,
});

function PetsoBooking() {
  const { t } = useTranslation();
  return <ComingSoonPage featureName={t('navigation.bookAppointment')} />;
}


